import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, PropType, Ref, ref } from "vue";
import { IBusStop } from "@/domain/entities/busStop";
import InfoModal from "@/components/shared/modal/base/InfoModal.vue";
import dayjs from "dayjs";
import DOMPurify from "dompurify";
import InlineSvg from "vue-inline-svg";
import { PROVIDE_KEY_NEXT_BUS_STOP_CHANGE_DATE_TIME } from "@/types";


const __default__ = {
  name: "BusStopChangeTextAndModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  busStop: {
    type: Object as PropType<IBusStop>,
    required: true,
  },
  isInsideShuttle: {
    type: Boolean,
    default: false,
  },
  isBookable: {
    type: Boolean,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const nextBusStopChangeDateTime = inject(
  PROVIDE_KEY_NEXT_BUS_STOP_CHANGE_DATE_TIME
) as Ref<string | undefined> | undefined;

const getMatchedChangeDate = (busStop: IBusStop) => {
  const { useBeginDtm, useEndDtm } = busStop;

  if (!nextBusStopChangeDateTime?.value) return;

  const busStopDates = [useBeginDtm, useEndDtm].filter(Boolean);
  return busStopDates.find((dtm) =>
    dayjs(dtm).isSame(nextBusStopChangeDateTime?.value, "minute")
  );
};

/** 변경 예정 여부 */
const willBeChanged = computed(() => {
  const chageDate = getMatchedChangeDate(props.busStop);
  if (!chageDate) {
    return false;
  }

  return dayjs(chageDate).isAfter(dayjs());
});

/** 정류장 변경 안내 문구 */
const busStopChangeText = computed(() => {
  const { useEndDtm } = props.busStop;

  const chageDate = getMatchedChangeDate(props.busStop);
  const statusLabel = chageDate === useEndDtm ? "폐지" : "추가";
  const changeDateText =
    dayjs(chageDate).format("HH:mm") === "00:00"
      ? dayjs(chageDate).format("M/D")
      : dayjs(chageDate).format("M/D HH:mm");

  return `${changeDateText}부터 ${statusLabel} 예정`;
});

/** 정류장 폐지 안내 모달 내용 */
const deleteGguideContentHtml = computed(() => {
  const targetDayjs = dayjs(getMatchedChangeDate(props.busStop));

  const changeDateText = targetDayjs.format("M월 D일");

  const tabName =
    targetDayjs.format("HH:mm") === "00:00"
      ? `${targetDayjs.format("M/D")} 이후`
      : `${targetDayjs.format("M/D HH:mm")} 이후`;

  const text = `이 정류장은 <span class="emphasis">${changeDateText}부터 노선에서 폐지될 예정</span>입니다. 즐겨찾기에서도 삭제되며, 더 이상 이용하실 수 없습니다.<br />즐겨찾기 한 정류장이라면 <span class="emphasis">[${tabName}]</span> 탭에서 다시 등록해 주세요.`;

  return DOMPurify.sanitize(text);
});

/** 정류장 추가 안내 모달 내용 */
const addGguideContentHtml = computed(() => {
  const chageDate = getMatchedChangeDate(props.busStop);
  const targetDateText = dayjs(chageDate).format("M월 D일");
  const targetDateTimeText =
    dayjs(chageDate).format("HH:mm") === "00:00"
      ? targetDateText
      : dayjs(chageDate).format("M월 D일 HH:mm");

  const text = `이 정류장은 ${targetDateText}부터 노선에 추가됩니다.<br />해당 정류장은 지금 즐겨찾기 등록이 가능하지만,<br /><span class="emphasis">실제 이용은 ${targetDateTimeText}부터 가능</span>합니다.`;

  return DOMPurify.sanitize(text);
});

const shouldShowBusStopDeleteGuide = ref(false);

const toggleShowBusStopDeleteGuide = (show: boolean) => {
  shouldShowBusStopDeleteGuide.value = show;
};

const shouldShowBusStopAddGuide = ref(false);

const toggleShowBusStopAddGuide = (show: boolean) => {
  shouldShowBusStopAddGuide.value = show;
};

const onClickHelpIcon = () => {
  if (!willBeChanged.value) return;

  if (props.busStop.useEndDtm) {
    toggleShowBusStopDeleteGuide(true);
  } else {
    toggleShowBusStopAddGuide(true);
  }
};

const __returned__ = { props, nextBusStopChangeDateTime, getMatchedChangeDate, willBeChanged, busStopChangeText, deleteGguideContentHtml, addGguideContentHtml, shouldShowBusStopDeleteGuide, toggleShowBusStopDeleteGuide, shouldShowBusStopAddGuide, toggleShowBusStopAddGuide, onClickHelpIcon, InfoModal, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})